const baseURL = "https://catalogo.nikelioficina.com/";
// const baseURL = "http://127.0.0.1:3001";

export default baseURL;
